export default __webpack_public_path__ + "static/treneri-jiri-sevcik-f0a88a1a75705b3a43ee4466a3c0b0fd.jpg";